export default __webpack_public_path__ + "static/media/menu.7eb4318b.svg";